export default __webpack_public_path__ + "static/media/include_8_male@3x.6506d592.jpg";